export default class Anchor {
    public title: string = '';
    public level: string = '2';
    public id: string = '';
    public position: number = 0;
    public children: Anchor[] = [];

    public constructor(init?:Partial<Anchor>) {
        Object.assign(this, init);
    }
}